export async function getConfirmSelectedShipping({
  csrf_token,
  partner_id,
  xhr,
}) {
  const myHeaders = new Headers();
  myHeaders.append(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  );

  const urlencoded = new URLSearchParams();
  urlencoded.append("csrf_token", csrf_token);
  urlencoded.append("partner_id", partner_id);
  urlencoded.append("xhr", xhr);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  try {
    const endpoint = "/shop/checkout";
    const fullUrl = `${window.location.origin}${endpoint}`;
    const response = await fetch(fullUrl, requestOptions);
    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error calling getConfirmSelectedShipping:", error);
    throw error;
  }
}
